import { useThemeColor } from '@/hooks/useThemeColor';

interface SearchResultCounterProps {
    prefixLabel?: string;
    suffixLabel?: string;
    allCount?: number;
}

export default function SearchResultCounter({ prefixLabel, suffixLabel, allCount }: SearchResultCounterProps) {
    const { scheme } = useThemeColor();
    const count = typeof allCount === 'number' ? allCount : 0;

    return (
        <div className="font-notojp font-bold text-xs lg:text-sm text-color-base flex flex-row items-center lg:flex-row w-full">
            <div className="flex pr-3">{prefixLabel}</div>
            <span className={`flex justify-center font-montserrat text-xl lg:text-3xl ${scheme?.text} tracking-widest`}>
                {count}
            </span>
            <div className="flex pl-2">{suffixLabel}</div>
        </div>
    );
}
